<template>
  <div class="task-fields">
    <!-- <perfect-scrollbar :options="{suppressScrollY: true}" class="multiple-fields-scroll"> -->
      <draggable v-model="taskOrder" @update="taskSortHandler" :disabled="true">
        <div :class="getClassForTaskField(task)+' '+checkUser(task.taskFields)" class="d-flex flex-row field-block" v-for="(task, index) in tasks" :key="'task'+index">
          <div class="field-control-wrapper field-control-wrapper__title" :class="{'no-radius': (index != tasks.length-1)}">
            <TaskTitle :fullDeliverables="fullDeliverables" :deliverableId="deliverableId" :deliverable="deliverable" :totalTasks="tasks.length" :task="task" :index="index" @toggleTaskFields="showTaskFields" />
          </div>
          <div
            class="d-none d-lg-block field-rows"
            :class="getClasses(taskField)+' toggleTaskField__'+task.id"
            v-for="(taskField, index1) in task.taskFields"
            :key="'taskField'+index1"
          >
            <CustomFields :fullDeliverables="fullDeliverables" :sortEnabledFields="['status', 'status_note', 'user', 'due_date', 'request']" :taskCount="tasks.length" :multipleTasks="index == 0" :deliverable="deliverable" :users="users" :customField="taskField" :rows="1"></CustomFields>
          </div>
        </div>
        <AdditionalFields :deliverableType="deliverable.deliverable_template_id" :deliverableId="deliverableId" />
      </draggable>
    <!-- </perfect-scrollbar> -->
  </div>
</template>

<script>
import Vue from "vue";
import draggable from "vuedraggable";
import CustomFields from "../common/CustomField";
import TaskTitle from "./TaskTitle";
import AdditionalFields from "../common/AdditionalFields";
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["tasks", "users", "deliverableId", "myWeek", "deliverable", "fullDeliverables"],
  data() {
    return {
      showAdditionalFields: false
    }
  },
  components: {
    draggable,
    CustomFields,
    TaskTitle,
    AdditionalFields
  },
  mounted() {

  },
  computed: {
    ...mapGetters(["taskHighlighted", "deliverableFilter", "myWeekDeliverableFilter", "projectDeliverableListFilter"]),
    taskOrder: {
      get: function() {
        return this.deliverable.tasks
      },
      set: function(newValue) {
        this.deliverable.tasks = newValue
      }
    }
  },
  methods: {
    ...mapActions(["updateFieldValue"]),
    taskSortHandler() {
      localStorage.setItem('storedSortKey', 'created_date')
      localStorage.setItem('storedSortState', 'ASC')
      localStorage.setItem('nextSortState', 'DESC')
      localStorage.setItem('storedSortFieldId', null)
      this.$store.state.deliverables.storedSortKey = 'created_date'
      this.$store.state.deliverables.storedSortState = 'ASC'
      this.$store.state.deliverables.nextSortState = 'DESC'
      this.$store.state.deliverables.storedSortFieldId = null
      // this.$store.commit('updateReorderedTasks', {taskData: this.taskOrder, deliverableId: this.deliverableId})
      this.$store.dispatch('saveTaskOrder', {taskData: this.taskOrder, deliverableId: this.deliverableId})
    },
    showTaskFields(taskId) {
      if($('.toggleTaskField__'+taskId).hasClass('d-none')) {
        $('.toggleTaskField__'+taskId).removeClass('d-none');
      } else {
        $('.toggleTaskField__'+taskId).addClass('d-none');
      }
    },

    getClasses(task) {
      let classes = "field-control-wrapper";
      if (task) {
        classes += " field-control-wrapper__"+task.field_key;
      }
      return classes;
    },

    checkUser(taskFields) {
      if(!this.myWeek) return;
      let classes = "";
      if (taskFields) {
        if(_.find(taskFields, {field_key: 'user'}).value != localStorage.getItem('userId')) {
          return "diff-user";
        }
      }
    },

    getClassForTaskField(task) {
      let isHighlight = task.id == this.taskHighlighted ? 'highlight' : '';
      let isUserHighlight = this.isUserSelected(task) ? 'user-highlight' : ''

      return this.checkUser(task.taskFields) + ' ' + isHighlight + ' ' + isUserHighlight;
    },

    isUserSelected(task) {
      let filterUsed = null;
      if (this.myWeek) {
        filterUsed = this.myWeekDeliverableFilter;
      } else if (this.$router.currentRoute.name == 'projectDeliverable') {
        filterUsed = this.projectDeliverableListFilter;
      } else {
        filterUsed = this.deliverableFilter;
      }

      if (task.taskFields) {
        if ((Array.isArray(task.taskFields) && task.taskFields.length)) {
          const taskUserValue = _.find(task.taskFields, { field_key: 'user' }).value;
          if (filterUsed.coordinator) {
            let isSame = false;
            filterUsed.coordinator.forEach(x => {
              if (x.id == taskUserValue) isSame = true;
            })
            return isSame;
          }
        }
      }

      return false;
    }
  },
};
</script>

<style>
</style>
